import Component from '@glimmer/component'
import type TeacherResourcesCurriculumMapsRoute from 'teacher-ui-client/teacher-resources/curriculum-maps/route'
import { PageHeader } from 'teacher-ui-client/components/page-header'
import { t } from 'ember-intl'
import { CurriculumMapTile } from 'teacher-ui-client/components/curriculum-map-tile'
import RouteTemplate from 'ember-route-template'

interface Signature {
  Args: {
    model: ModelFor<TeacherResourcesCurriculumMapsRoute>
  }
}

export class TeacherResourcesCurriculumMapsPage extends Component<Signature> {
  get curriculumMaps() {
    return (
      this.args.model.curriculumMaps
        ?.filter((entry) => entry.fields.cover?.fields.file?.url && entry.fields.file?.fields.file?.url)
        .map((entry) => ({
          title: entry.fields.title,
          description: entry.fields.description,
          subscriptionType: entry.fields.subscriptionType,
          // @ts-expect-error - we're filtering out entries without a cover or file url so these will always be defined
          coverUrl: entry.fields.cover.fields.file.url,
          // @ts-expect-error - we're filtering out entries without a cover or file url so these will always be defined
          fileUrl: entry.fields.file.fields.file.url,
        }))
        .sort((a, b) => a.title.localeCompare(b.title)) ?? []
    )
  }

  <template>
    <div class="mx-auto my-8 w-full px-8">

      <PageHeader>
        <:title>
          <h1>
            {{t "sideNav.maths.curriculumMap"}}
          </h1>
        </:title>
      </PageHeader>

      <div class="mt-4 flex flex-wrap justify-center gap-4">
        {{#each this.curriculumMaps as |curriculumMap|}}
          <CurriculumMapTile
            class="w-72"
            @title={{curriculumMap.title}}
            @coverUrl={{curriculumMap.coverUrl}}
            @fileUrl={{curriculumMap.fileUrl}}
          />
        {{/each}}
      </div>

    </div>
  </template>
}

export default RouteTemplate(TeacherResourcesCurriculumMapsPage)
